import { useState } from 'react';

const CategoryTabs = (props) => {
    const [activeTab, setActiveTab] = useState(0);

    const HomePageCatManuCard = (manufacturer) => {
        return (
            <div className="card" key={manufacturer.Name}>
                <a href={manufacturer.ListingsUrl}>
                    <div className="content">
                        <strong>{manufacturer.Name}</strong>
                    </div>
                </a>
                <img src={manufacturer.ImgUrl} loading='lazy' />
            </div>
        );
    };

    return (
        <div className="container">
            <h2>{props.SectionTitle}</h2>
            <p>{props.SectionDescription}</p>
            <div className="tab-container">
                <div className="tab-buttons">
                    {props.CategoryTabs?.map((category, index) => (
                        <button
                            key={`btn-${index}`}
                            className={`tab-button ${activeTab === index ? 'active' : ''}`}
                            id={`btn-${index + 1}`}
                            onClick={() => setActiveTab(index)}
                        >
                            {category.Name}
                        </button>
                    ))}
                </div>
                {props.CategoryTabs.map((category, index) => (
                    <div
                        key={`content-${index}`}
                        className="tab-content"
                        id={`content-${index + 1}`}
                        style={{ display: activeTab === index ? 'block' : 'none' }}
                    >
                        <div className="content">
                            <div className="card-container">
                                {category.ManufacturerCards?.map(manufacturer => 
                                    HomePageCatManuCard(manufacturer)
                                )}
                            </div>
                            {category.Description && <p>{category.Description}</p>}
                            {category.Url && (
                                <a className='ts-rounded-button rac-button' href={category.Url}>
                                    {category.LinkText}
                                </a>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoryTabs;